import Link from "next/link";
import Image from "next/future/image";
import {ConditionalWrapper} from '@/components/conditional_wrapper.js'
import { cameraIcon, targetIcon, resizeFullIcon, dot3Icon } from '@/lib/icons.js';
import { useState, createRef, useEffect, useRef } from "react";

export default function ApplicationPhotoTile(props){
  function TileContent(props) {
    return (<div className="image-non-action">
      <Image 
        unoptimized 
        priority
        src={props.app_photo.image_url} 
        alt={props.app_photo.title + ' photo'} 
        className='lexcms-app-photo-image'
        width='100'
        height='0'
      />
      { props.app_photo.new &&
      <div className='overlay-pill new-photo-pill'>New Photo</div>
      }
      { props.app_photo.product_hot_spots && props.app_photo.product_hot_spots.length > 0 &&
        <div className='hot-spot-count-container'>          
          { targetIcon }<p>({props.app_photo.product_hot_spots.length})</p>
        </div>
      }
    </div>)
  }

  function OverlayButtons(props) {
    return (<div className='overlay-action-buttons-container'>
      { props.showLightBox && 
      <button className='overlay-action-button overlay-expand-action-button' 
        onClick={(e) => { props.highlight ? props.showLightBox(e, props.app_photo): props.showLightBox(e, props.index) }}>
        { resizeFullIcon } Expand
      </button>
      }
      <a className='overlay-action-button overlay-details-action-button'
        href={`/lex-cms/inspiration/application_photo/${props.app_photo.id}`}>
        { dot3Icon } Details
      </a>
     </div>)
  }

  return (
    <div className='lexcms-application-photo-tile'>
      { props.mobile ? (  
        <Link href={`/lex-cms/inspiration/application_photo/${props.app_photo.id}`}>
          <div  className={`lexcms-app-photo-image-container`}> 
            <TileContent {...props}  />
          </div>
        </Link> ) : 
          (<div className="lexcms-app-photo-tile-desktop">
            <div className="lexcms-app-photo-image-container">
              <TileContent {...props}  />
              <OverlayButtons {...props} />
            </div> 
          </div>
          )
      }
    </div>
  )
}
